export const CustomLiveboardCategoryId = "custom-liveboards-category-id";
